// extracted by mini-css-extract-plugin
export var downArrow = "_i6-0";
export var infoTooltipIcon = "_i6-3";
export var label = "_i6-1";
export var optionCard = "_i6-4";
export var upArrow = "_i6-2";